export const markAsVisitedTranslations = {
    en: {
        title: "Mark as Visited?",
        beneficiary: "Beneficiary",
        mobile: "Mobile",
        dob: "DOB",
        confirmButton: "Confirm & Mark Visited",
        successMessage: "Beneficiary marked as registered",
        notAvailable: "N/A"
    },
    mr: {
        title: "भेट दिल्याचे चिन्हांकित करा?",
        beneficiary: "लाभार्थी",
        mobile: "मोबाईल",
        dob: "जन्मतारीख",
        confirmButton: "पुष्टी करा आणि भेट दिल्याचे चिन्हांकित करा",
        successMessage: "लाभार्थी नोंदणीकृत म्हणून चिन्हांकित केले",
        notAvailable: "उपलब्ध नाही"
    }
};
